import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { ContentProps } from '@atlaskit/popup';
import type { Ati } from '@atlassian/ari';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type {
	PopupContentQueries,
	PopupContentNestedEntryPoints,
	UniversalCreateItems,
	MenuItem,
	CrossAppCreationConfig,
	MenuSectionV2,
	PopupContentExtraProps,
} from '../../../types';
import type { UniversalCreateButtonPropsBase } from '../../../types/button';
import type { UniversalCreateButtonPropsBase as UniversalCreateButtonPropsBaseV2 } from '../../../types/buttonV2';

type EntryPointParams = {};

export const popupContentEntryPoint: EntryPoint<
	EntryPointComponent<
		PopupContentQueries,
		PopupContentNestedEntryPoints,
		| (UniversalCreateButtonPropsBase & {
				buttonOnly?: false;
				isOpen?: boolean;
				items: UniversalCreateItems;
				preventClose?: boolean;
				primaryActionItem?: MenuItem;
				selectedItem?: Ati;
				shouldRenderToParent?: boolean;
		  } & {
				contentProps: ContentProps;
				isOpen: boolean;
				onClose: () => void;
		  })
		| (UniversalCreateButtonPropsBaseV2 & {
				buttonOnly?: false;
				crossAppCreationConfig?: CrossAppCreationConfig;
				isOpen?: boolean;
				preventClose?: boolean;
				primaryActionItem?: MenuItem;
				sections: MenuSectionV2[];
				selectedItem?: Ati;
				shouldRenderToParent?: boolean;
				suggestionConfig?: never;
		  } & {
				contentProps: ContentProps;
				isOpen: boolean;
				onClose: () => void;
		  }),
		PopupContentExtraProps
	>,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlassian-universal-create_popup-content" */ '../PopupContent'
			).then((module) => module.PopupContent),
		{
			moduleId: 'universal-create-popup-content',
		},
	),
	getPreloadProps: (_params: EntryPointParams) => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
